import React from "react";
import SetupMaster from "./SetupMaster";

/* Menu Setup — restores legacy Admin/RE_Admin_MenuSetup.aspx
   (SP_RE_Admin_Menu_Query / _Save, RE_SP_Menu_Delete over RE_Setup_MasterMenu).

   A row with an empty URL is a section header; a row with a URL and a parent is a link inside
   that section. PRIORITY orders siblings. ICON CODE is the MUI icon name used for a section
   (ShoppingCart, Build, ManageAccounts, Inventory, Assessment, PointOfSale, Summarize,
   GavelSharp) — AdminLayout maps it, so a section's icon can change without a deploy.

   What appears in a user's sidebar is decided by Role Rights, not here. */

const config = {
    entity: "Menu",
    title: "MENU",
    addLabel: "Add Menu",
    pk: "MENU_ID",
    endpoints: {
        list: "services/query/Setups/Menu.php",
        save: "services/mutation/Setups/Menu.php",
        del: "services/delete/setup/DeleteMenu.php"
    },
    lookups: [
        { stateKey: "menus", endpoint: "services/query/Setups/Menu.php", valueField: "MENU_ID", labelField: "MENU_TEXT" }
    ],
    fields: [
        { name: "MENU_TEXT", label: "Menu Text", type: "text", required: true, md: 3 },
        { name: "MENU_URL", label: "URL (blank = section)", type: "text", md: 3 },
        { name: "PARENT_ID", label: "Parent Section", type: "select", lookup: "menus", md: 3 },
        { name: "MENU_PRIORITY", label: "Priority", type: "number", md: 1 },
        { name: "ICON_CODE", label: "Icon Code", type: "text", md: 2 },
        { name: "MENU_ACTIVE", label: "Active (1/0)", type: "number", md: 1 },
    ],
    columns: [
        { label: "SECTION", field: "PARENT_TEXT" },
        { label: "MENU TEXT", field: "MENU_TEXT" },
        { label: "URL", field: "MENU_URL" },
        { label: "PRIORITY", field: "MENU_PRIORITY", align: "right" },
        { label: "ICON", field: "ICON_CODE" },
        { label: "ACTIVE", field: "MENU_ACTIVE", align: "center" },
    ]
};

export default function MenuSetup(props) {
    return <SetupMaster config={config} {...props} />;
}
